import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import DocumentSubcategory, {
  newDocumentSubcategory,
} from "../../models/document-subcategory";
import DocumentSubcategoryForm from "./DocumentSubcategoryForm";

interface DocumentSubcategoryUpdateModalProps {
  show: boolean;
  documentSubcategory?: DocumentSubcategory;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const DocumentSubcategoryUpdateModal: React.FC<
  DocumentSubcategoryUpdateModalProps
> = ({ show, documentSubcategory, onCancel, onSuccess }) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialDocumentSubcategory, setInitialDocumentSubcategory] =
    useState<DocumentSubcategory>(
      documentSubcategory ? documentSubcategory : newDocumentSubcategory()
    );

  const modalTitle = documentSubcategory
    ? `Editar Subcategoría de documento: ${documentSubcategory.name}`
    : `Crear Subcategoría de documento nueva`;

  const onClose = () => {
    setInitialErrors({});
    setInitialDocumentSubcategory(newDocumentSubcategory());
    onCancel();
  };
  useEffect(() => {
    setInitialDocumentSubcategory(
      documentSubcategory ? documentSubcategory : newDocumentSubcategory()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentSubcategory]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <DocumentSubcategoryForm
            initialDocumentSubcategory={initialDocumentSubcategory}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default DocumentSubcategoryUpdateModal;
